import { Workflows } from 'components/workflows';

const WorkflowsPage = () => {
  return <Workflows />;
};

export default WorkflowsPage;
